import React from "react";
import styled from "styled-components";
const Styles = styled.div`
  margin-bottom: 1rem;
  flex-direction: row;
  justify-content: center;
  position: relative;
  display: flex;
  flex-grow: 1;
  height: 40px;
  width: 100%;
  .box-container {
    flex-grow: 1;
    height: 100%;
    display: flex;
  }
  input[type="radio"] {
    /* visibility: hidden; 1 */
    height: 0; /* 2 */
    width: 0; /* 2 */
  }

  label {
    height: calc(100% - 10px);
    display: flex;
    flex: auto;
    vertical-align: middle;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 8px;
    user-select: none;
    background-color: var(--n-grey-1);
    border: 1px solid var(--n-grey-3);
    color: var(--n-grey-7);
  }

  input[type="radio"]:checked + label {
    background: var(--n-primary-4);
    color: #fff;
  }

  @media screen and (max-width: 1110px) {
    margin: 0 !important;
    flex-direction: column;
    justify-content: center;
    position: relative;
    display: flex;
    height: 100% !important;
    width: 100% !important;
    /* padding: 10px 10px; */
    input[type="radio"] {
      /* visibility: hidden; 1 */
      height: 0; /* 2 */
      width: 0; /* 2 */
    }

    label {
      display: flex;
      flex: auto;
      vertical-align: middle;
      align-items: center;
      justify-content: center;
      text-align: center;
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 8px;
      user-select: none;
      margin-right: 8px;
      background-color: #fff;
      border: 1px solid #a19f9d;
      color: #a19f9d;
    }

    input[type="radio"]:checked + label {
      background: var(--n-primary-4);
      color: #fff;
    }
  }
`;

export const CheckboxProfile = ({ style, value , name, onchange }) => {
  if (window.innerWidth > 1110) { 
    return (
      <Styles style={{display: "flex", gap: "0.5rem" ,...style}}>
        <div className="box-container">
        <input type="radio" name={name} checked={(value === 'male')} id="size_1" value="male" onChange={onchange}/>
        <label for="size_1">Male</label>
        </div>
        <div className="box-container">
        <input type="radio" name={name} checked={(value === 'female')} id="size_2" value="female" onChange={onchange}/>
        <label for="size_2">Female</label>
        </div>
      </Styles>
    );
  } else {
    return (
      <Styles style={style}>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <input type="radio" name={name} checked={(value === 'male')} id="size_1" value="male" onChange={onchange}/>
          <label for="size_1">Male</label>
          <input type="radio" name={name} checked={(value === 'female')} id="size_2" value="female" onChange={onchange}/>
          <label for="size_2">Female</label>
        </div>
      </Styles>
    );
  }
};
